import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IApiResponseBody } from '../../../common/models/common';
import { RootState } from '../../app.model';
import { booleanLookup } from '../../../common/constants/common';
import { IConfigSoftwareDeviceTypeState } from './configSoftwareDeviceType.model';
import {
  deleteConfigSoftwareDeviceType,
  getConfigSoftwareDeviceTypeById,
  saveConfigSoftwareDeviceType,
  searchConfigSoftwareDeviceType,
} from './configSoftwareDeviceType.action';
import { IConfigSoftwareDeviceType } from '../../../services/master/configSoftwareDeviceType/configSoftwareDeviceType.model';

export const initialState: IConfigSoftwareDeviceTypeState = {
  search: {
    loading: false,
    hasErrors: false,
    data: [],
    count: 0,
    lookups: {},
    tableName: '',
  },
  tableColumnSelection: {
    id: null,
    table_name: null,
    columns: {},
  },
  getById: {
    loading: false,
    hasErrors: false,
    data: null,
  },
  save: {
    loading: false,
    hasErrors: false,
    messages: [],
  },
  delete: {
    loading: false,
    hasErrors: false,
    messages: [],
  },
};

export const configSoftwareDeviceTypeSlice = createSlice({
  name: 'configSoftwareDeviceType',
  initialState,
  reducers: {
    clearConfigSoftwareDeviceType: () => {
      return initialState;
    },
    clearConfigSoftwareDeviceTypeMessages: (state) => {
      state.save.messages = [];
      state.delete.messages = [];
    },
    clearConfigSoftwareDeviceTypeGetById: (state) => {
      state.getById.data = null;
    },
    setTableColumnSelection: (state, action: PayloadAction<{ [key: string]: boolean }>) => {
      state.tableColumnSelection.columns = action.payload;
    },
  },
  extraReducers: {
    // Search
    [searchConfigSoftwareDeviceType.pending.type]: (state) => {
      state.search.loading = true;
    },
    [searchConfigSoftwareDeviceType.fulfilled.type]: (state, action: PayloadAction<any>) => {
      const { records, total_count, table_name, column_selection } = action.payload;
      state.search.data = records;
      state.search.count = total_count;
      state.search.lookups = { booleanLookup };
      state.search.loading = false;
      state.search.hasErrors = false;
      state.search.tableName = table_name;
      if (column_selection) {
        state.tableColumnSelection.id = column_selection.id;
        const tableSelectionObj = JSON.parse(column_selection.columns as any);
        if (tableSelectionObj.columns) {
          state.tableColumnSelection.column_orders = tableSelectionObj.column_orders;
          state.tableColumnSelection.columns = tableSelectionObj.columns;
        } else {
          state.tableColumnSelection.columns = tableSelectionObj;
        }
      }
      state.tableColumnSelection.table_name = table_name;
    },
    [searchConfigSoftwareDeviceType.rejected.type]: (state) => {
      state.search.loading = false;
      state.search.hasErrors = true;
    },

    // Get by id
    [getConfigSoftwareDeviceTypeById.pending.type]: (state) => {
      state.getById.loading = true;
    },
    [getConfigSoftwareDeviceTypeById.fulfilled.type]: (
      state,
      action: PayloadAction<IConfigSoftwareDeviceType>
    ) => {
      state.getById.data = action.payload;
      state.getById.loading = false;
      state.getById.hasErrors = false;
    },
    [getConfigSoftwareDeviceTypeById.rejected.type]: (state) => {
      state.getById.loading = false;
      state.getById.hasErrors = true;
    },

    // Save
    [saveConfigSoftwareDeviceType.pending.type]: (state) => {
      state.save.loading = true;
      state.save.messages = [];
    },
    [saveConfigSoftwareDeviceType.fulfilled.type]: (
      state,
      action: PayloadAction<IApiResponseBody<unknown>>
    ) => {
      state.save.loading = false;
      state.save.hasErrors = false;
      state.save.messages = action.payload.messages;
    },
    [saveConfigSoftwareDeviceType.rejected.type]: (state) => {
      state.save.loading = false;
      state.save.hasErrors = true;
    },

    // Delete
    [deleteConfigSoftwareDeviceType.pending.type]: (state) => {
      state.delete.loading = true;
      state.delete.messages = [];
    },
    [deleteConfigSoftwareDeviceType.fulfilled.type]: (
      state,
      action: PayloadAction<IApiResponseBody<unknown>>
    ) => {
      state.delete.loading = false;
      state.delete.hasErrors = false;
      state.delete.messages = action.payload.messages;
    },
    [deleteConfigSoftwareDeviceType.rejected.type]: (state) => {
      state.delete.loading = false;
      state.delete.hasErrors = true;
    },
  },
});

// A selector
export const configSoftwareDeviceTypeSelector = (state: RootState) => state.configSoftwareDeviceType;

// Actions
export const {
  clearConfigSoftwareDeviceType,
  clearConfigSoftwareDeviceTypeMessages,
  clearConfigSoftwareDeviceTypeGetById,
  setTableColumnSelection,
} = configSoftwareDeviceTypeSlice.actions;

// The reducer
export default configSoftwareDeviceTypeSlice.reducer;
